module.exports = __webpack_public_path__ + "static/media/poster-top.fcd1e1f4.jpeg";